"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    const { leftBlock, rightBlock } = element.value;
    const sections = [];
    if (leftBlock) {
        const leftText = leftBlock.text
            ? (0, rich_text_1.slateToMarkdown)(leftBlock.text, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim()
            : '';
        if (leftText) {
            sections.push(`### Left Panel\n\n${leftText}\n\n`);
        }
        if (leftBlock.showImage && leftBlock.image) {
            const url = (0, md_utils_1.getFileUrl)(leftBlock.image, context);
            if (url) {
                sections.push(`![Image](${url})\n\n`);
            }
        }
    }
    if (rightBlock) {
        const rightText = rightBlock.text
            ? (0, rich_text_1.slateToMarkdown)(rightBlock.text, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim()
            : '';
        if (rightText) {
            sections.push(`### Right Panel\n\n${rightText}\n\n`);
        }
        if (rightBlock.showImage && rightBlock.image) {
            const url = (0, md_utils_1.getFileUrl)(rightBlock.image, context);
            if (url) {
                sections.push(`![Image](${url})\n\n`);
            }
        }
    }
    return sections.join('');
};
exports.toMarkdown = toMarkdown;
